<template>
  <tr>
    <td>
      {{ item.street }}
    </td>
    <td>
      {{ item.zip }}
    </td>
    <td>
      {{ item.city }}
    </td>
    <td>
      {{ item.description ? item.description : '-' }}
    </td>
    <td>
      {{ item.office ? item.office.name : '-' }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_client_addresses',
          })
        "
        class="buttons"
      >
        <WorkClientAddressModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-client']['address-dialog-delete'][
              'udalit-adres'
            ] +
            ' ' +
            item.street +
            ' ' +
            item.zip +
            ' ' +
            item.city
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkClientAddressModal from 'components/workClient/address/WorkClientAddressModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkClientAddressTableItem',
  components: { WorkClientAddressModal, DeleteModal },
  props: ['item'],
}
</script>

<style lang="scss" scoped>
td {
  .role {
    padding: 4px 8px;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    width: max-content;
    background-color: #52525f;
  }
  .avatar {
    height: 100%;
    display: grid;
    justify-content: start;
    align-items: center;
    .avatar_body {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #16558f;
      display: grid;
      justify-content: center;
      align-items: center;
      transition: inherit;
      img {
        border-radius: inherit;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  &:nth-child(1) {
    width: auto;
  }
  &:nth-child(2) {
    width: max-content;
  }
  &:nth-child(3) {
    width: auto;
  }
  &:nth-child(4) {
    width: auto;
  }
  &:nth-child(5) {
    width: auto;
  }
  &:nth-child(6) {
    width: auto;
  }
}
</style>
